module.exports = __webpack_public_path__ + "static/img/active3.d1000f4a.png";